module.exports = __webpack_public_path__ + "img/cv-template-7.c47069b1.png";